export default __webpack_public_path__ + "static/media/delivery1.b4630c0e.jpg";